// PRHero.js - Australia
import React from 'react';
import { motion } from 'framer-motion';
import { CALENDLY_PR_AUSTRALIA } from '../../../constants';

const PRHero = () => {
  const handleBookConsultation = () => {
    if (CALENDLY_PR_AUSTRALIA) {
      window.open(CALENDLY_PR_AUSTRALIA, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section className="relative w-full h-[600px] md:h-[700px] overflow-hidden bg-white">
      <div className="max-w-7xl mx-auto h-full grid md:grid-cols-2">
        {/* Left Content */}
        <div className="flex flex-col justify-center px-4 md:px-8 py-12 bg-surface">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <span className="inline-block bg-white text-secondary text-xs font-light px-4 py-2 rounded-md mb-4">
              Australia - Permanent Residency
            </span>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-primary leading-tight mb-6">
              Making Australia Your Permanent Home
            </h1>
            
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-8 max-w-xl font-light">
              Australia's skilled migration system turns on points, occupation lists and nomination rounds. We work out where you sit within it, whether that means General Skilled Migration or a state and territory programme, and stay alongside you from the first eligibility check through to the visa grant.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={handleBookConsultation}
                className="bg-primary hover:bg-primary-hover text-white font-normal text-sm px-8 py-3 rounded-lg transition-colors text-center"
              >
                Talk to a PR Adviser
              </button>
            </div>
          </motion.div>
        </div>

        {/* Right Image */}
        <div className="relative hidden md:block">
          <div 
            className="absolute inset-0 bg-cover bg-center"
            style={{ 
              backgroundImage: `url(${require('../../../assets/australia-pr-hero.jpg')})`,
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default PRHero;
